/* eslint-disable no-unused-vars */
import {
  useEffect,
  useState,
} from 'react';

import {
  Button,
  Spin,
} from 'antd';

import { DownloadOutlined } from '@ant-design/icons';
import {
  Document,
  Font,
  Image,
  Page,
  PDFDownloadLink,
  PDFViewer,
  StyleSheet,
  Text,
  View,
} from '@react-pdf/renderer';

import aptosDisplay from '../../Fonts/Aptos-Display.ttf';
import aptosMono from '../../Fonts/Aptos-Mono.ttf';
import aptosSemibold from '../../Fonts/Aptos-Semibold.ttf';
import imgBandRLogo from '../../Library/bandrlogo';
import * as Consts from '../../Library/Consts';
import GenUtil from '../../Library/GenUtil';

const fontName = 'Aptos';

Font.register({
  family: fontName,
  fonts: [
    {
      src: aptosDisplay
    },
    {
      src: aptosSemibold,
      fontWeight: 600
    },
    {
      src: aptosMono,
      fontStyle: 'italic'
    }
  ]
});

const styles = StyleSheet.create({
  page: {
    padding: 50,
    backgroundColor: '#fff',
    fontFamily: fontName,
    fontSize: 11
  },
  container: {

  },
  table: {
    display: "table",
    width: "100%"
  },
  totalTable: {
    width: "100%",
    display: "table",
    marginTop: 12,
  },
  tableRow: {
    flexDirection: "row",
  },
  tableRowAlt: {
    flexDirection: "row",
    backgroundColor: "#E4EEF3",
  },
  tableColHeader: {
    padding: 8,
    fontStyle: 'italic',
  },
  tableCol: {
    padding: 8,
  },
  tableColAlt: {
    padding: 8,
    backgroundColor: "#E4EEF3",
  },
  tableCol33: {
    width: "33%"
  },
  tableCol50: {
    width: "50%"
  },
  tableCol100: {
    width: "100%"
  },
  brBusinessInfo: {
    textAlign: 'right',
    color: '#7F7F7F',
    paddingBottom: 4,
    fontSize: 9
  },
  quoteHeader: {
    textAlign: 'center',
    color: '#005C9A',
    marginTop: 16,
    marginBottom: 16,
    fontSize: 13,
    fontStyle: 'italic'
  },
  quoteInfoLabel: {
    marginTop: 8,
    fontWeight: 600
  },
  quoteInfoData: {
    marginTop: 8
  },
  quoteSubject: {
    marginTop: 20,
    fontSize: 14,
    fontWeight: 600
  },
  termsFooter: {
    marginTop: 12,
    fontSize: 12,
    textAlign: 'center'
  },
  signatureLine: {
    margin: 18,
    fontSize: 12,
    textAlign: 'justify'
  },
  signature: {
    fontWeight: 'bold',
    marginLeft: 18,
    paddingTop: 18,
    textAlign: 'left'
  },
  msrp: {
    fontFamily: fontName,
    fontSize: 10,
    color: '#7F7F7F',
    textAlign: 'right',
    marginTop: 6
  }
});


function PDFExport(props) {
  useEffect(() => {
    // Force loading and wait for loading to finish
    Promise.all([
      Font.load({ fontFamily: fontName }),
      Font.load({ fontFamily: fontName, fontWeight: 600 }),
      Font.load({ fontFamily: fontName, fontStyle: 'italic' })
    ]).then(() => {
      setLoading(false);
    })
  }, []);

  const [loading, setLoading] = useState(true);


  function renderStateAbbrev(usState) {
    // convert the long state name back to state abbrev, using the consts value loaded from runtimeconfig.js
    let idx = Consts.GET_STATES().findIndex((o) => o.name === usState);
    let abbrev = Consts.GET_STATES()[idx].abbrev;
    return abbrev;
  }

  const MyDocument = () => {

    let printQuote = JSON.parse(JSON.stringify(props.curQuote));
    let quoteTitle = `${printQuote.quoteNumber} - ${printQuote.subject}.pdf`
    let hideDuration = true;
    let showSignature = false;
    if (printQuote.signatureLine) {
      showSignature = true;
    }

    let totalSale = 0;
    printQuote.salesItems.forEach(si => {
      if (si.termDuration && si.billingPlan) {
        hideDuration = false;
      }
      totalSale = totalSale + si.totalSale;
    });

    printQuote.totalSale = totalSale;

    let totalSaleMsrp = 0;
    printQuote.salesItems.forEach(si => {
      totalSaleMsrp = totalSaleMsrp + (si.msrp * si.quantity);
    });

    printQuote.totalSaleMsrp = totalSaleMsrp;

    return (
      <Document title={quoteTitle}>
        <Page size="LETTER" style={styles.page}>
          <View style={[styles.container]}>
            <View style={[styles.table]}>
              <View style={styles.tableRow}>
                <View style={[styles.tableCol50]}>
                  <Image src={imgBandRLogo} style={{ width: 152, height: 36 }}></Image>
                </View>
                <View style={[styles.tableCol50]}>
                  <Text style={[styles.brBusinessInfo]}>524 Brighton Ave. Unit 2, Spring Lake, NJ 07762</Text>
                  <Text style={[styles.brBusinessInfo]}>Phone: 732.845.5002 Fax: 732.845.8145</Text>
                  <Text style={[styles.brBusinessInfo]}>bandrsolutions.com</Text>
                </View>
              </View>
            </View>

            <View style={[styles.table]}>
              <View style={styles.tableRow}>
                <View style={[styles.tableCol100]}>
                  <Text style={[styles.quoteHeader]}>QUOTATION</Text>
                </View>
              </View>
            </View>

            <View style={[styles.table]}>
              <View style={styles.tableRow}>
                <View style={[styles.tableCol33]}>
                  <Text style={[styles.quoteInfoLabel]}>Ship To/Bill To:</Text>
                  <Text style={[styles.quoteInfoData]}>{printQuote.brClient.busName1}</Text>
                  {printQuote.brClient.busName2.length > 0 &&
                    <Text style={[styles.quoteInfoData]}>{printQuote.brClient.busName2}</Text>
                  }
                  <Text style={[styles.quoteInfoData]}>{printQuote.brClient.street1}</Text>
                  {printQuote.brClient.street2.length > 0 &&
                    <Text style={[styles.quoteInfoData]}>{printQuote.brClient.street2}</Text>
                  }
                  <Text style={[styles.quoteInfoData]}>{printQuote.brClient.city}, {renderStateAbbrev(printQuote.brClient.usState)} {printQuote.brClient.zip}</Text>
                </View>
                <View style={[styles.tableCol33]}>
                  <Text style={[styles.quoteInfoLabel]}>Quote Number:</Text>
                  <Text style={[styles.quoteInfoData]}>{printQuote.quoteNumber}</Text>
                  <Text style={[styles.quoteInfoLabel]}>Contact:</Text>
                  <Text style={[styles.quoteInfoData]}>{printQuote.brClient.contactName1}</Text>
                  {printQuote.brClient.contactName2.length > 0 &&
                    <Text style={[styles.quoteInfoData]}>{printQuote.brClient.contactName2}</Text>
                  }
                </View>
                <View style={[styles.tableCol33]}>
                  <Text style={[styles.quoteInfoLabel]}>Quote Date:</Text>
                  <Text style={[styles.quoteInfoData]}>{GenUtil.dateOnlyToString2(printQuote.quoteDate)}</Text>
                  <Text style={[styles.quoteInfoLabel]}>Quote Expiration:</Text>
                  <Text style={[styles.quoteInfoData]}>{GenUtil.dateOnlyToString2(printQuote.quoteExpires)}</Text>
                </View>
              </View>
            </View>

            <View style={[styles.table]}>
              <View style={styles.tableRow}>
                <View style={[styles.tableCol100, { paddingBottom: 12 }]}>
                  <Text style={[styles.quoteSubject]}>{printQuote.subject}</Text>
                </View>
              </View>
            </View>

            <View style={[styles.table]}>
              <View style={[styles.tableRow, { borderBottom: '1px solid black' }]}>
                <View style={[styles.tableColHeader, { width: "8%", textAlign: "right" }]}>
                  <Text>QTY</Text>
                </View>
                <View style={[styles.tableColHeader, { width: "40%" }]}>
                  <Text>DESCRIPTION</Text>
                </View>
                <View style={[styles.tableColHeader, { width: "12%" }]}>
                    {!hideDuration &&  <Text>BILLED</Text>  }
                </View>
                <View style={[styles.tableColHeader, { width: "8%" }]}>
                      {!hideDuration &&  <Text>TERM</Text>  }
                </View>
                <View style={[styles.tableColHeader, { width: "16%", textAlign: "right" }]}>
                  <Text>RATE</Text>
                </View>
                <View style={[styles.tableColHeader, { width: "16%", textAlign: "right" }]}>
                  <Text>TOTAL</Text>
                </View>
              </View >
              {
                printQuote.salesItems.map((o, i) => (
                  <View style={[i % 2 ? styles.tableRowAlt : styles.tableRow]} key={i} wrap={false}>
                    <View style={[i % 2 ? styles.tableColAlt : styles.tableCol, { width: "8%", textAlign: "right" }]}>
                      <Text>{new Intl.NumberFormat('en-US', { maximumSignificantDigits: 9 }).format(o.quantity)}</Text>
                    </View>
                    <View style={[i % 2 ? styles.tableColAlt : styles.tableCol, { width: "40%" }]}>
                      <Text>{o.description}</Text>
                    </View>                  
                    <View style={[i % 2 ? styles.tableColAlt : styles.tableCol, { width: "12%" }]}>
                          {!hideDuration &&<Text>{o.billingPlan}</Text>}
                    </View>
                    <View style={[i % 2 ? styles.tableColAlt : styles.tableCol, { width: "8%" }]}>
                          {!hideDuration &&<Text>{o.termDuration}</Text>}
                    </View>
                    <View style={[i % 2 ? styles.tableColAlt : styles.tableCol, { width: "16%", textAlign: "right" }]}>
                      <Text>{GenUtil.numberToCurrency(o.sellPrice, true)}</Text>
                      {printQuote.showMsrp &&
                        <><br /><Text style={styles.msrp}>{'(' + GenUtil.numberToCurrency(o.msrp, true) + ')'}</Text></>
                      }
                    </View>
                    <View style={[i % 2 ? styles.tableColAlt : styles.tableCol, { width: "16%", textAlign: "right" }]}>
                      <Text>{GenUtil.numberToCurrency(o.totalSale, true)}</Text>
                      {printQuote.showMsrp &&
                        <><br /><Text style={styles.msrp}>{'(' + GenUtil.numberToCurrency(o.msrp * o.quantity, true) + ')'}</Text></>
                      }
                    </View>
                  </View>
                ))
              }
            </View >

            <View style={[styles.totalTable]}>
              {printQuote.taxRate > 0 &&
                <>
                  <View style={styles.tableRow} wrap={false}>
                    <View style={[styles.tableColHeader, { width: "84%", textAlign: "right" }]}>
                      <Text>SUBTOTAL</Text>
                    </View>
                    <View style={[styles.tableCol, { width: "16%", textAlign: "right" }]}>
                      <Text>{GenUtil.numberToCurrency(printQuote.totalSale, true)}</Text>
                    </View>
                  </View>
                  <View style={styles.tableRow} wrap={false}>
                    <View style={[styles.tableColHeader, { width: "84%", textAlign: "right" }]}>
                      <Text>{`${printQuote.taxLabel} (${GenUtil.numberToPrint(printQuote.taxRate, 4, '', '%', true)})`}</Text>
                    </View>
                    <View style={[styles.tableCol, { width: "16%", textAlign: "right" }]} wrap={false}>
                      <Text>{GenUtil.numberToCurrency(printQuote.totalSale * (printQuote.taxRate / 100), true)}</Text>
                    </View>
                  </View>
                </>
              }
              <View style={styles.tableRow} wrap={false}>
                <View style={[styles.tableColHeader, { width: "84%", textAlign: "right" }]}>
                  <Text>TOTAL</Text>
                  {printQuote.showMsrp &&
                    <><Text style={styles.msrp}>MSRP</Text></>
                  }
                </View>
                <View style={[styles.tableCol, { width: "16%", textAlign: "right" }]}>
                  <Text>{GenUtil.numberToCurrency(printQuote.totalSale * ((printQuote.taxRate / 100) + 1), true)}</Text>
                  {printQuote.showMsrp &&
                    <><Text style={styles.msrp}>{'(' + GenUtil.numberToCurrency(printQuote.totalSaleMsrp * ((printQuote.taxRate / 100) + 1), true) + ')'}</Text></>
                  }
                </View>
              </View>
              {printQuote.showAnnualized &&
                <View style={styles.tableRow} wrap={false}>
                  <View style={[styles.tableColHeader, { width: "84%", textAlign: "right" }]}>
                    <Text>ANNUALIZED TOTAL</Text>
                    {printQuote.showMsrp &&
                      <><Text style={styles.msrp}>MSRP</Text></>
                    }
                  </View>
                  <View style={[styles.tableCol, { width: "16%", textAlign: "right" }]}>
                    <Text>{GenUtil.numberToCurrency(12 * printQuote.totalSale * ((printQuote.taxRate / 100) + 1), true)}</Text>
                    {printQuote.showMsrp &&
                      <><Text style={styles.msrp}>{'(' + GenUtil.numberToCurrency(12 * printQuote.totalSaleMsrp * ((printQuote.taxRate / 100) + 1), true) + ')'}</Text></>
                    }
                  </View>
                </View>
              }
            </View>

            {
              printQuote.showTermsFooter === true && (
                <View style={[]} wrap={false}>
                  <Text style={[styles.termsFooter]}>
                    {Consts.GET_TERMS_FOOTER()}
                  </Text>
                </View>
              )
            }

            {showSignature === true &&
              <View style={[]} wrap={false}>
                <Text style={[styles.signatureLine]}>
                  {printQuote.signatureLine}
                </Text>
                <Text style={[styles.signature]}>
                  Name:
                </Text>
                <Text style={[styles.signature]}>
                  Date:
                </Text>
              </View>
            }

          </View >
        </Page >
      </Document >
    );
  };

  return (
    <>
      {
        loading && (
          <div className='wbs25 align-center'>
            <Spin tip="Rendering..."></Spin>
          </div>
        )
      }
      {
        !loading && (
          <>
            <div className='wbs25'>
              <PDFDownloadLink document={<MyDocument />} fileName={`${props.curQuote.quoteNumber} - ${props.curQuote.subject}.pdf`}>
                {({ loading }) =>
                  !loading && <Button type='primary' icon={<DownloadOutlined />}>Download</Button>
                }
              </PDFDownloadLink>
            </div>

            <div className='wbs25'>
              <PDFViewer style={{ width: '100%', height: 800, border: '0 none', padding: 0, margin: 0 }}>
                <MyDocument />
              </PDFViewer>
            </div>
          </>
        )
      }
    </>
  );
}

export default PDFExport;